import Section from '../../components/Section';
import styled from 'styled-components';

const EnhancedSection = styled(Section)`
  display: flex;
  flex-direction: column;

  > h3 {
    font-weight: 500;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 4px;
    color: ${({ theme }) => theme.colors.INK_800};
  }
`;

EnhancedSection.Description = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin: 0;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.colors.INK_600};
`;

export default EnhancedSection;
